"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = fetchEntity;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _effects = require("redux-saga/effects");

var _entityKey = _interopRequireDefault(require("./entityKey"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(fetchEntity);

var devMode = typeof process !== 'undefined' && process.env.NODE_ENV === 'development';
/* istanbul ignore next */

var sanitizeArgs = function sanitizeArgs(argArray) {
  if (!Array.isArray(argArray)) {
    throw new Error("argArray ".concat(JSON.stringify(argArray), " is not an array!"));
  }

  return argArray.map(function (arg) {
    if (typeof arg === 'function') {
      return '*a function*';
    }

    if ((0, _typeof2["default"])(arg) === 'object' && arg) {
      if (arg.constructor === Object || typeof arg.constructor === 'undefined') {
        return arg;
      }

      return '*a weird object*';
    }

    return arg;
  });
};

function fetchEntity(entity, args) {
  var _ref,
      _ref$shouldThrow,
      shouldThrow,
      _ref$key,
      key,
      argsObject,
      keyToUse,
      response,
      _args = arguments;

  return _regenerator["default"].wrap(function fetchEntity$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$shouldThrow = _ref.shouldThrow, shouldThrow = _ref$shouldThrow === void 0 ? true : _ref$shouldThrow, _ref$key = _ref.key, key = _ref$key === void 0 ? undefined : _ref$key;
          argsObject = devMode ? {
            args: sanitizeArgs(args)
          } : {};
          keyToUse = (0, _entityKey["default"])(key, entity, args);
          _context.next = 5;
          return (0, _effects.put)(entity.requestAction((0, _objectSpread2["default"])({}, argsObject, {
            key: keyToUse
          })));

        case 5:
          _context.prev = 5;
          _context.next = 8;
          return _effects.call.apply(void 0, [entity.promise].concat((0, _toConsumableArray2["default"])(args)));

        case 8:
          response = _context.sent;
          _context.next = 11;
          return (0, _effects.put)(entity.successAction((0, _objectSpread2["default"])({
            data: response
          }, argsObject, {
            key: keyToUse
          })));

        case 11:
          return _context.abrupt("return", response);

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](5);
          _context.next = 18;
          return (0, _effects.put)(entity.errorAction((0, _objectSpread2["default"])({
            data: _context.t0
          }, argsObject, {
            key: keyToUse
          }, shouldThrow ? {} : {
            error: _context.t0
          })));

        case 18:
          if (!shouldThrow) {
            _context.next = 20;
            break;
          }

          throw _context.t0;

        case 20:
          return _context.abrupt("return", _context.t0);

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[5, 14]]);
}